import { render, staticRenderFns } from "./system-parameter-manage.vue?vue&type=template&id=b5f5ff12"
import script from "./system-parameter-manage.vue?vue&type=script&lang=ts"
export * from "./system-parameter-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports